var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitterStroke = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 34,
  height: 30,
  viewBox: "0 0 34 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.1304 13.0772L29.9489 2.64559L31.34 1H29.1852H26.9798H26.5157L26.2161 1.3544L18.9881 9.90449L13.2731 1.44041L12.9757 1H12.4443H5H3.11818L4.17123 2.55959L13.508 16.3875L4.23634 27.3544L2.8451 29H5H7.20554H7.66962L7.96922 28.6456L15.65 19.5599L21.7269 28.5596L22.0243 29H22.5557H30H31.8818L30.8288 27.4404L21.1304 13.0772ZM16.6929 14.5768L9.90046 4.68958H10.8616L16.9135 13.4992L16.9135 13.4992L17.9024 14.9386L17.9024 14.9386L25.0806 25.3873H24.1195L17.8576 16.2726V16.2721L17.6818 16.0162L16.6929 14.5768L16.6929 14.5768Z",
  fill: "black",
  stroke: "white",
  strokeWidth: 2
})));
export { SvgTwitterStroke as ReactComponent };
export default __webpack_public_path__ + "static/media/twitterStroke.e3cee07c.svg";